import { Component, Input } from '@angular/core'
import { Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { GetGuestEmails } from '@tv3/store/guest/guest.actions'
import { TableType } from '@tv3/shared/empty-table/table-type'
import { MessageSidePanelService } from '@tv3/containers/inquiries/dialogs/message/message-side-panel.service'
import { Message } from '@tv3/store/message/message.model'
import { Guest } from '@tv3/store/guest/guest.model'

@Component({
  selector: 'app-guest-email-list',
  templateUrl: './guest-email-list.component.html',
  host: { class: 'messages' },
  styleUrls: ['./guest-email-list.component.scss'],
})
export class EditGuestEmailListComponent {
  @Input() set guest(g: Guest) {
    this.guestItem = g

    if (!this.guestItem.emailMessages) {
      this.store.dispatch(GetGuestEmails({ guest: this.guestItem }))
    }
  }

  guestItem: Guest

  tableType = TableType.GuestEmailsList

  constructor(private store: Store<fromRoot.State>, private messageSidePanelService: MessageSidePanelService) {}

  onEdit(guest: Message) {
    this.messageSidePanelService.open(guest.inquiryId, guest.messageId)
  }
}
